import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bangkok/unlock-prize.png")